import Drawer from "../../../drawer/Drawer";
import TagManage from "./TagManage";

const TagMangeDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
  type = "post-tags",
  title = "Blog",
}) => {
  return (
    <>
      <Drawer
        open={open}
        onClose={(val) => {
          close(val);
        }}
        actualSize={"xl"}
        size={"xl3"}
        title={data?._id ? `Update ${title} Tag` : `Add ${title} Tag`}
        subtitle=""
        drawerBodyClass="p-0 max-h-[calc(100%-90px)]"
      >
        <div className="h-full overflow-y-auto">
          <TagManage
            getResponse={getResponse}
            close={close}
            data={data}
            type={type}
          />
        </div>
      </Drawer>
    </>
  );
};

export default TagMangeDrawer;
